export default class View {
  _data;

  clearContainer() {
    this._parentEl.innerHTML = "";
  }
}
